import {injectable} from 'inversify';

import type {OfferModel} from './Offer.model';

import {BaseController} from '../../../core/domain/Base/Base.controller';

@injectable()
export class OfferController extends BaseController<OfferModel> {
  constructor() {
    super();
  }
}
